export enum SCTypeEnum {
    K1 = 1,
    K11 = 11,
    K2 = 2,
    K3 = 3,
}

export type SCTypeStrings = (typeof SCTypeEnum)[keyof typeof SCTypeEnum];

export const VectorTypeEnum = Object.freeze({
    Phase: {name: "Phase",},
    Linear: {name: "Linear",},
    Sequence: {name: "Sequence",}
});

export const POWER = "S";
export const CURRENT = "I";
export const VOLTAGE = "U";
export const RESISTANCE = "Z";

export const ParamType = Object.freeze({
    Power: {name: "S", nameEq: "$\\dot S$", showLine: false},
    Current: {name: "I", nameEq: "$\\dot I$", showLine: false},
    Voltage: {name: "U", nameEq: "$\\dot U$", showLine: true},
    Resistance: {name: "Z", nameEq: "$\\underline{Z}$", showLine: false},
});

const Colors = Object.freeze({
    orange: "orange",
    green: "green",
    red: "red",
    darkorange: "darkorange",
    darkgreen: "darkgreen",
    darkred: "darkred",
    black: "black",
});

export const VectorGraphParam = Object.freeze({
    PhA: {
        name: "a",
        line_widths: 2,
        legendgroup: VectorTypeEnum.Phase,
        color: Colors.darkorange,
        shiftpointname: 0.20
    },
    PhB: {
        name: "b",
        line_widths: 2,
        legendgroup: VectorTypeEnum.Phase,
        color: Colors.darkgreen,
        shiftpointname: 0.30
    },
    PhC: {name: "c", line_widths: 2, legendgroup: VectorTypeEnum.Phase, color: Colors.darkred, shiftpointname: 0.40},
    SeqA1: {
        name: "a1",
        line_widths: 1,
        legendgroup: VectorTypeEnum.Sequence,
        color: Colors.orange,
        shiftpointname: 0.65
    },
    SeqA2: {
        name: "a2",
        line_widths: 1,
        legendgroup: VectorTypeEnum.Sequence,
        color: Colors.orange,
        shiftpointname: 0.65
    },
    SeqA0: {
        name: "a0",
        line_widths: 1,
        legendgroup: VectorTypeEnum.Sequence,
        color: Colors.orange,
        shiftpointname: 0.65
    },
    SeqB1: {
        name: "b1",
        line_widths: 1,
        legendgroup: VectorTypeEnum.Sequence,
        color: Colors.green,
        shiftpointname: 0.65
    },
    SeqB2: {
        name: "b2",
        line_widths: 1,
        legendgroup: VectorTypeEnum.Sequence,
        color: Colors.green,
        shiftpointname: 0.65
    },
    SeqB0: {
        name: "b0",
        line_widths: 1,
        legendgroup: VectorTypeEnum.Sequence,
        color: Colors.green,
        shiftpointname: 0.65
    },
    SeqC1: {
        name: "c1",
        line_widths: 1,
        legendgroup: VectorTypeEnum.Sequence,
        color: Colors.red,
        shiftpointname: 0.65
    },
    SeqC2: {
        name: "c2",
        line_widths: 1,
        legendgroup: VectorTypeEnum.Sequence,
        color: Colors.red,
        shiftpointname: 0.65
    },
    SeqC0: {
        name: "c0",
        line_widths: 1,
        legendgroup: VectorTypeEnum.Sequence,
        color: Colors.red,
        shiftpointname: 0.65
    },
    LineAB: {
        name: "ab",
        line_widths: 1,
        legendgroup: VectorTypeEnum.Linear,
        color: Colors.black,
        shiftpointname: 0.75
    },
    LineBC: {
        name: "bc",
        line_widths: 1,
        legendgroup: VectorTypeEnum.Linear,
        color: Colors.black,
        shiftpointname: 0.75
    },
    LineCA: {
        name: "ca",
        line_widths: 1,
        legendgroup: VectorTypeEnum.Linear,
        color: Colors.black,
        shiftpointname: 0.85
    }
});